import React from "react";
import Text from "@/components/ui/text";
import { IconButton } from "@/components/ui/icon-button";
import CounterBadge from "@/components/ui/counter-badge";
import { Close } from "@dreamhub/designsystem/icons";

interface PopoverHeaderProps {
  title: string;
  badge?: number;
  onClose?: () => void;
  actions?: React.ReactNode;
}

const PopoverHeader: React.FC<PopoverHeaderProps> = ({
  title,
  badge,
  onClose,
  actions
}) => {
  return (
    <div className="w-full pl-4 py-2 pr-2 flex items-center justify-between border-b border-border-border1">
      <div className="flex items-center gap-2">
        <Text variant="lgLabel">{title}</Text>
        {badge !== undefined && <CounterBadge count={badge} />}
      </div>
      <div className="flex items-center gap-1">
        {actions}
        {onClose && (
          <IconButton variant="iconNoBg" iconColor="secondary" size="md" onClick={onClose}>
            <Close />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default PopoverHeader;
